import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Modal, Loading } from '@binance-chain/honeycomb'
import QRC from 'qrcode.react'
import { Consumer as WalletClientConsumer } from '../../context/WalletConnectProvider'

import { setWalletConnectURI } from '../../../redux/walletConnect/action'
import { withI18n } from '../../../i18n/util'

import { Title, QRCodeContainer, TextNote } from './styled'

class WalletConnectModal extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.func.isRequired,
    wcUri: PropTypes.string,
    formatI18nText: PropTypes.func.isRequired,
  }

  static defaultProps = {
    wcUri: '',
  }

  _onModalClosed = walletConnectClient => {
    const { dispatch } = this.props
    walletConnectClient.connected && walletConnectClient.disconnect()
    dispatch(setWalletConnectURI(''))
  }

  _renderTitle = () => {
    const { formatI18nText } = this.props

    return (
      <>
        <Title>{formatI18nText('unlockWallet.title')}</Title>
        <Loading />
      </>
    )
  }

  render() {
    const { wcUri, formatI18nText } = this.props
    if (!wcUri) return null

    return (
      <WalletClientConsumer>
        {walletConnectClient => (
          <Modal
            open={!!wcUri}
            onClose={() => {
              this._onModalClosed(walletConnectClient)
            }}
          >
            <Modal.Header title={this._renderTitle()} />
            <Modal.Content>
              <TextNote>{formatI18nText('unlockWallet.description')}</TextNote>
              <QRCodeContainer>
                <QRC value={wcUri || ''} size={200} level="M" includeMargin={true} />
              </QRCodeContainer>
              <TextNote>
                <i className="i" />
                {formatI18nText('unlock.walletConnect.recommendedWallet')}:{' '}
                <span>
                  <a href="https://trustwallet.com/">Trust Wallet</a>{' '}
                </span>
                <span>
                  , <a href="https://safepal.io/">SafePal</a>{' '}
                </span>
                <span>
                  , <a href="https://www.coolwallet.io/">CoolWallet S</a>
                </span>
                <span>
                  , <a href="https://www.mathwallet.org/en/">Math Wallet</a>
                </span>
                <span>
                  , <a href="https://meet.one/">Meet.one</a>
                </span>
                <span>
                  ,{' '}
                  <a href="https://chrome.google.com/webstore/detail/equal-wallet-the-metamask/blnieiiffboillknjnepogjhkgnoapac?hl=en">
                    Equal
                  </a>
                </span>
                <span>
                  , <a href="https://atomicwallet.io/">Atomic Wallet</a>
                </span>
              </TextNote>
            </Modal.Content>
          </Modal>
        )}
      </WalletClientConsumer>
    )
  }
}

const mapStateToProps = ({ walletConnect: { wcUri } }) => ({
  wcUri,
})

export default withI18n(connect(mapStateToProps)(WalletConnectModal))
